import React from 'react';
import { AuthContext, useAuthState } from './hooks/useAuth';

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * AuthProvider Component
 * 
 * Provides authentication context to the entire application
 * Wraps the app and makes auth state available everywhere
 */
export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const authState = useAuthState();

  return (
    <AuthContext.Provider value={authState}>
      {children}
    </AuthContext.Provider>
  );
};